import styled from '@emotion/styled'
import CenterContainer from './CenterContainer'
import errorIcon from '../assets/images/error.svg'
import { useRouteError } from 'react-router'
import { useEffect } from 'react'


const LoadingContainer = styled(CenterContainer)`
  & > div {
    h1 {
      font-weight: bold;
      margin-top: 2em;
    }
  }
`

export function ErrorPage() {
  const error = useRouteError()
  useEffect(() => {
    console.error(error)
  }, [error])
  return (
    <LoadingContainer>
      <div className="flex flex-col items-center">
        <img src={errorIcon} width={128} height={128} alt="" />
        <br />
        <h1>เกิดข้อผิดพลาด โปรดลองใหม่อีกครั้ง</h1>
      </div>
    </LoadingContainer>
  )
}
